// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
export const getTimelineUrl = (versionId?: string, location = window.location) => {
	const timelineUrl = `${location.pathname.split('/calendar')[0]}/timeline`;
	if (versionId) {
		return `${timelineUrl}?version=${versionId}`;
	}
	return timelineUrl;
};
